// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const breadcrumbsClasses = {
  item: "qui-breadcrumbs__item",
  itemIcon: "qui-breadcrumbs__item-icon",
  itemTrigger: "qui-breadcrumbs__item-trigger",
  list: "qui-breadcrumbs__list",
  overflowTrigger: "qui-breadcrumbs__overflow-trigger",
  root: "qui-breadcrumbs__root",
  separator: "qui-breadcrumbs__separator",
} as const
